import React, {Component} from 'react'
import PropTypes from 'prop-types'
import showLocationType from "../../../../../vietnamese/showLocationType"


class BasketLocation extends Component {
    render() {
        return (
            <td className='BasketLocation'>
                {showLocationType(this.props.location)}
            </td>
        )
    }
}

BasketLocation.propTypes = {
    location: PropTypes.string.isRequired,
}

export default BasketLocation
